import React from "react";
import { t } from "@lingui/macro";

import { Tooltip, TOOLTIP_POSITION } from "widgets/feedback";
import {
  KfIcon,
  KF_ICONS,
  ICON_SIZE,
  ICON_STROKE,
  ICON_PADDING
} from "widgets/kficon";
import { handleCommunityRedirection } from "account/community";

import { useAccountStore } from "@base/common/libs/stores/account.js";

import styles from "../styles.css";

export const Help = () => {
  let preference = useAccountStore.getState().Preference || {};
  let disableHelpMenu = preference._disable_help_menu;

  if (disableHelpMenu) return null;

  return (
    <div className={styles.helpNav}>
      <Tooltip
        content={t`Get help from the Kissflow Community`}
        position={TOOLTIP_POSITION.BOTTOM}
      >
        <div
          className={`${styles.helpNavbutton} helpButton`}
          onClick={() => handleCommunityRedirection(true)}
        >
          <KfIcon
            icon={KF_ICONS.HELP}
            size={ICON_SIZE.SIZE_20}
            stroke={ICON_STROKE.REGULAR}
            padding={ICON_PADDING.PADDING_8}
            className={styles.helpMenuIcon}
          />
        </div>
      </Tooltip>
    </div>
  );
};
